import React, { useRef, useEffect, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import axios from 'axios';
import { base_url } from "constant/constant";
import { useSearchParams } from 'react-router-dom';
import ContractPdf from "./ContractPdf";
import {Paper} from "@mui/material";
import { toast } from 'react-toastify';

const SignatureComponent = () => {
  const [searchParams] = useSearchParams();
  const generatedPdfId = searchParams.get('id');


const sigPad = useRef<SignatureCanvas | null>(null);
const [isSubmitting, setIsSubmitting] = useState(false);
const [signed, setSigned] = useState(false);
const [contract, setContract] = useState<any | null>(null);
/** Annexes sent with the lease, in the order the back office arranged them. */
const [annexes, setAnnexes] = useState<any[]>([]);
const [booking, setBooking] = useState<any | null>(null);
const [companyInfo, setCompanyInfo] = useState(null);
const [generatedContractPdf, setGeneratedContractPdf] = useState<any | null>(null);
const city = booking?.property_id?.city || booking?.property_id?.location;

useEffect(() => {
  const generatedContractPdf = async () => {
    try {
      const response = await axios.get(
        `${base_url}/contract/fetch_generated_contract_pdf?id=${generatedPdfId}`,
          
      );
      if (response.data.error === false) {
        const responseGenratedPdf = response.data?.generatedContractPdf[0]
        setGeneratedContractPdf(responseGenratedPdf)
        const bookingId = responseGenratedPdf?.booking_id;
        const contractId = responseGenratedPdf?.contract_id;

        if (bookingId) {
          fetchBooking(bookingId);
        }

        if (contractId) {
          fetchContract(contractId);
        }

        fetchAnnexes(responseGenratedPdf?.annex_ids);
      }
    } catch (error) {
      console.error("Failed to fetch generated pdf:", error);
    }
  };
  generatedContractPdf();
}, []);

const fetchContract = async (contractId: any) => {
  try {
    const response = await axios.get(
      `${base_url}/contract/get_contract_by_id/${contractId}`
    );
    if (response.data.error === false) {
      setContract(response.data?.contract);
    }
  } catch (error) {
    console.error("Failed to fetch contract:", error);
  }
};

// Fetched in sequence rather than with Promise.all so the annexes stay in the
// order the back office arranged them — the same order the generated PDF uses.
// If one fails to load the whole list is dropped: showing a partial document
// would be worse than showing none, because the tenant would sign believing
// they had seen everything.
const fetchAnnexes = async (annexIds: any[]) => {
  if (!Array.isArray(annexIds) || annexIds.length === 0) {
    setAnnexes([]);
    return;
  }
  try {
    const loaded = [];
    for (const annexId of annexIds) {
      const response = await axios.get(
        `${base_url}/contract/get_contract_by_id/${annexId}`
      );
      if (response.data.error !== false) throw new Error("Annex not found");
      loaded.push(response.data?.contract);
    }
    setAnnexes(loaded);
  } catch (error) {
    console.error("Failed to fetch annexes:", error);
    setAnnexes([]);
    toast.error("Could not load the annexes for this contract. Please refresh before signing.");
  }
};
const fetchBooking = async (bookingId: any) => {
  try {
    const response = await axios.get(
      `${base_url}/booking/booking-detatils?id=${bookingId}`
    );
    if (response.data.error === false) {
      setBooking(response.data.data);
    }
  } catch (error) {
    console.error("Failed to fetch booking:", error);
  }
};

useEffect(() => {
  const fetchCompany = async () => {
    try {
      const response = await axios.get(
        `${base_url}/company/get_company?city=${city}`
      );
      if (response.data.error === false) {
        setCompanyInfo(response.data.data[0]);
      }
    } catch (error) {
      console.log("Error fetching company details");
    }
  };

  fetchCompany();
}, [city]);


const clear = () => {
  if (sigPad.current) {
    sigPad.current.clear();
  }
};

const save = async () => {
  if (!sigPad.current || sigPad.current.isEmpty()) {
    return alert("Please provide a signature");
  }
  const signatureData = sigPad.current.getCanvas().toDataURL("image/png");

  setIsSubmitting(true);
  try {
    const response = await axios.post(`${base_url}/contract/save-signature`, {
      signatureData,
      contract,
      generatedPdfId,
      language: generatedContractPdf?.language
    });
    if (response.data.error === false) {
    toast.success('Signature submitted') 
    setSigned(true);
    } else {
      toast.error(`${response.data.title}`)
    }

  } 
    catch (error) {
    console.error(error);
    toast.error("Error submitting signature.");
  } finally {
    setIsSubmitting(false);
  }
};

if (generatedContractPdf?.isSigned === true) {
    return (
      <div className="container flex flex-col items-center justify-center min-h-screen text-center py-10">
        <h2 className="text-3xl font-semibold mb-4">Thank You!</h2>
        <p className="lg:text-lg text-base text-gray-600 dark:text-gray-300">
          You have already signed the contract.
        </p>
      </div>
    );
}

if (signed) {
  return (
       <div className="container flex flex-col items-center justify-center min-h-screen text-center py-10">
        <h2 className="text-3xl font-semibold mb-4">Thank You!</h2>
        <p className="lg:text-lg text:base text-gray-600 dark:text-gray-300">
          You have successfully signed the contract.
        </p>
      </div>
  )
}
  return (<>
   { ! (generatedContractPdf?.isSigned) &&
    <div className="container ListingDetailPage__content md:py-[1rem] lg:px-[16rem]" >

      <h2 className="lg:my-2 my-1 lg:text-2xl text-lg darkTitleForHeader inline-block pl-8 ">Review and Sign Your Contract</h2>

      <Paper className="lg:p-[25px] p-[0px]" >
       <ContractPdf  language = {generatedContractPdf?.language} contract={contract} annexes={annexes} booking={booking} companyInfo = {companyInfo} sigPad={sigPad} clear={clear} save={save}/>
      <p className="lg:text-sm text-xs text-semibold md:mt-8 mt-6">Sign Below : </p>
      <p className="mb-3">
        <u className="lg:text-sm text-xs">
          Please sign with your finger ( mobile / Tablet ) or mouse ( Pc, Mac version )
        </u>
      </p>

      <SignatureCanvas 
        penColor="black"
        canvasProps={{ className: 'sigCanvas border border-gray-400 lg:w-[500px] lg:h-[200px] w-[100%] h-[200px]',}}
        ref={sigPad}
      />

      <div className="button-group flex gap-6 pt-5 pb-8" >
        <button onClick={clear} className="clear-btn p-2 lg:text-sm text-xs" style={{ color: "rgb(12, 88, 110)"}}>Clear</button>
        <button onClick={save} className="confirm-btn py-1 px-2 border rounded-3xl lg:text-sm text-xs" style={{ backgroundColor: "rgb(12, 88, 110)", color:"white"}}>{isSubmitting ? "Submitting..." : "Submit Signature"}</button>
      </div>
      </Paper>

    </div>}
     </>
  );
};

export default SignatureComponent;
